<div class="contact-wrapper">
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
    </div>
    <!-- LOGIN -->
    <div class="sign-in-form" *ngIf="nextModal == 'login'">
        <header class="login-cta">
            <h2> {{'login' | translate}} </h2>
        </header>

        <form [formGroup]="formLogin" novalidate>
            <div class="form-row">
                <input type="text" name="email" formControlName="email" required />
                <span>Email</span>
            </div>
            <!-- Valid Email -->
            <div *ngIf="formLogin.controls['email'].invalid && (formLogin.controls['email'].dirty || formLogin.controls['email'].touched)" class="alert alert-danger">
                <div *ngIf="formLogin.controls['email'].errors.required">
                    {{'inputEmail' | translate}}
                </div>
                <div *ngIf="formLogin.controls['email'].errors.email">
                    {{'emailValid' | translate}}
                </div>
            </div>

            <div class="form-row">
                <input type="password" name="password" formControlName="password" required />
                <span>Mật Khẩu</span>
            </div>
            <!-- Valid Password -->
            <div *ngIf="formLogin.controls['password'].invalid && (formLogin.controls['password'].dirty || formLogin.controls['password'].touched)" class="alert alert-danger">
                <div *ngIf="formLogin.controls['password'].errors.required">
                    {{'inputPassword' | translate}}
                </div>
                <div *ngIf="formLogin.controls['password'].errors.minlength">
                    {{'passwordValid8chars' | translate}}
                </div>
                <div *ngIf="formLogin.controls['password'].errors.pattern">
                    {{'passwordValid' | translate}}
                </div>
            </div>
            <div *ngIf="msg_userBlocked != '' " style="color: red;">
                Tài khoản đã bị khóa!
            </div>
            <div *ngIf="msg_wrongAccount != '' " style="color: red;">
                Kiểm tra lại thông tin mật khẩu.
            </div>
            <div *ngIf="msg_userNotFound != '' " style="color: red;">
                Tài khoản của bạn chưa có mật khẩu, hãy Quên Mật Khẩu để được cấp mật khẩu.
            </div>
            <div class="form-row"></div>
            <div class="forgot">
                <a class="forgot-pass-link highlight" (click)="goForgotPassword()"> {{'forgotPassword' | translate}} ?</a>
            </div>

            <div class="form-row">
                <button type="submit"
                        [disabled]="formLogin.pristine || formLogin.invalid" class="btn btn-success"
                        (click)="login()"
                        >

                {{'btn_login' | translate}}
                </button>
            </div>

        </form>
        <div class="socials-wrapper">
            <header>
                <h2> {{'moreWaysLogin' | translate}} </h2>
            </header>
            <ul>
                <li>
                    <a class="facebook" (click)="loginWithFacebook()"
                        ><fa-icon
                            [icon]="faFacebookSquare"
                            class="icon"
                            size="xl"
                        ></fa-icon
                    ></a>
                </li>
                <!-- <li><a href="#" class="twitter"><i class="fab fa-twitter"></i></a></li> -->
                <!-- <li><a href="#" class="twitch"><i class="fab fa-twitch"></i></a></li> -->
                <li>
                    <a class="google" (click)="loginWithGoogle()"
                        ><fa-icon
                            [icon]="faGoogle"
                            class="icon"
                            size="xl"
                        ></fa-icon
                    ></a>
                </li>
            </ul>
        </div>
        <div class="create-aacount">
            {{'noAccount' | translate}}?
            <a class="text-underline sign-up-form-btn highlight"
                (click)="goRegisterTab()"
                > {{'createNow' | translate}} </a
            >
        </div>
    </div>
    <!-- REGISTER -->
    <div class="sign-up-form" *ngIf="nextModal == 'register'">
        <header class="login-cta">
            <h2> {{'register' | translate}} </h2>
            <ul>
                <li> {{'passwordValid8chars' | translate}} </li>
                <li> {{'passwordValid1' | translate}} </li>
                <li> {{'passwordValid2' | translate}} </li>
                <li> {{'passwordValid3' | translate}} </li>
            </ul>
        </header>
        <form [formGroup]="formRegister" novalidate>
            <div class="form-row">
                <input type="text" name="email" required formControlName="email"/>
                <span>Email</span>
            </div>
            <!-- Valid Email -->
            <div *ngIf="formRegister.controls['email'].invalid && (formRegister.controls['email'].dirty || formRegister.controls['email'].touched)" class="alert alert-danger">
                <div *ngIf="formRegister.controls['email'].errors.required">
                    {{'inputEmail' | translate}}
                </div>
                <div *ngIf="formRegister.controls['email'].errors.email">
                    {{'emailValid' | translate}}
                </div>
            </div>

            <div class="form-row">
                <input type="password" name="password" required formControlName="password"/>
                <span> {{'password' | translate}} </span>
            </div>
            <!-- Valid Password -->
            <div *ngIf="formRegister.controls['password'].invalid && (formRegister.controls['password'].dirty || formRegister.controls['password'].touched)" class="alert alert-danger">
                <div *ngIf="formRegister.controls['password'].errors.required">
                    {{'inputPassword' | translate}}
                </div>
                <div *ngIf="formRegister.controls['password'].errors.minlength">
                    {{'passwordValid8chars' | translate}}
                </div>
                <div *ngIf="formRegister.controls['password'].errors.pattern">
                    {{'passwordValid' | translate}}
                </div>
            </div>

            <div class="form-row">
                <input type="password" name="passwordConfirm" required formControlName="passwordConfirm"/>
                <span> {{'confirmPassword' | translate}} </span>
            </div>
            <!-- Valid Password Comfirm-->
            <div *ngIf="formRegister.controls['passwordConfirm'].invalid && (formRegister.controls['passwordConfirm'].dirty || formRegister.controls['passwordConfirm'].touched)" class="alert alert-danger">
                <div *ngIf="formRegister.controls['passwordConfirm'].errors.required">
                    {{'reEnterPassword' | translate}}
                </div>
                <div *ngIf="formRegister.controls['passwordConfirm'] !== formRegister.controls['password']">
                    {{'passwordNoMatching' | translate}}
                </div>
            </div>
            <!-- <div *ngIf="msgAccountExist != ''">
                {{msgAccountExist}}
            </div> -->
            <div style="color: red;" *ngIf="msg_AccountExisted != '' ">
                {{msg_AccountExisted}}
            </div>
            <div class="form-row"></div>
            <div class="form-row">
                <button type="button" (click)="goVerifyTab()" class="btn btn-success"
                [disabled]="formRegister.pristine || formRegister.invalid">
                    {{'btn_register' | translate}}
                </button>
            </div>

            <div class="create-aacount pt-3">
                <a  class="text-underline sign-in-form-btn highlight" (click)="goLoginTab()" >
                    {{'back' | translate}} </a
                >
            </div>
        </form>
    </div>
    <!-- VERIFY EMAIL -->
    <div class="verify-form" *ngIf="nextModal == 'verify'">
        <header class="login-cta">
            <h2> {{'emailVerification' | translate}} </h2>
            {{"sendPasswordMail" | translate}}
        </header>
        <form>
            <div class="form-row"></div>
            <div class="form-row">
                <button type="submit" (click)="goLoginTab()"> {{"btn_confirmed" | translate}} </button>
            </div>
            <div class="create-aacount pt-3">
                <a  class="text-underline sign-in-form-btn highlight" (click)="goRegisterTab()" >
                    {{'back' | translate}}
                </a>
            </div>
        </form>
    </div>
    <!-- FORGOT PASSWORD -->
    <div class="forgot-pass-form" *ngIf="nextModal == 'forgot'">
        <header class="login-cta">
            <h2> {{'forgotPassword' | translate}} </h2>
            {{'forgotPasswordNote' | translate}}
        </header>

        <form [formGroup]="formForgotPassword" novalidate>
            <div class="form-row">
                <input type="text" name="forgot-password" formControlName="email" required/>
                <span>Email</span>
            </div>
            <div style="color: red;" *ngIf="msg_AccountStrange != '' ">
                {{msg_AccountStrange}}
            </div>
            <div *ngIf="formForgotPassword.controls['email'].invalid && (formForgotPassword.controls['email'].dirty || formForgotPassword.controls['email'].touched)" class="alert alert-danger">
                <div *ngIf="formForgotPassword.controls['email'].errors.required">
                    {{'inputEmail' | translate}}
                </div>
                <div *ngIf="formForgotPassword.controls['email'].errors.email">
                    {{'emailValid' | translate}}
                </div>
            </div>
           <!-- <div class="form-group">
              <label for="">Email</label>
              <input type="email" placeholder="@mail.com">
           </div> -->
           <div class="form-row"></div>
            <div class="form-row">
                <button type="button" (click)="forgotPassword()"
                [disabled]="formForgotPassword.pristine || formForgotPassword.invalid"
                class="btn btn-success"
                >
                {{'resetPassword' | translate}}
                </button>
            </div>
           <div class="create-aacount">
              {{'gotNewPassword' | translate}}?
              <a class="go-to-sign-in highlight" (click)="goLoginTab()"> {{'btn_login' | translate}} </a>
           </div>
        </form>
    </div>

</div>


